import { jsx as _jsx } from "react/jsx-runtime";
import { Loading } from "@ssf/components";
import { useEffect } from "react";
import { useAuth } from "./index.js";
export const AuthGuard = ({ autoSignin, fallback, loading, children, }) => {
    const { isInitiated, user, signinRedirect } = useAuth();
    useEffect(() => {
        if (isInitiated && !user && autoSignin) {
            signinRedirect();
        }
    }, [isInitiated, user, autoSignin, signinRedirect]);
    if (!isInitiated) {
        return loading || _jsx(Loading, {});
    }
    if (!user) {
        return fallback || null;
    }
    return typeof children === "function" ? children(user) : children;
};
//# sourceMappingURL=AuthGuard.js.map